import request from '@/utils/request'
const qs = require('qs')

// 根据城市CODE获取城市SVG
export function getCitySvg (data) {
  return request({
    url: '/ooh-rim/v1/asset/getcitysvg',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
// 获取城市下的所有资产
export function getAllByCityCode (data) {
  return request({
    url: '/ooh-rim/v1/asset/getallbycitycode',
    method: 'post',
    data: qs.stringify(data),
    timeout: 200000
  })
}
